import { Injectable } from '@angular/core';

@Injectable()
export class HelperService {
    constructor() {
    }

    public distinct<T>(array: Array<T>, property: string): Array<T> {
        const uniqueArray = new Array<T>();
        const flags = {};
        for (let i = 0; i < array.length; i++) {
            if (flags[array[i][property]]) { continue; }
            flags[array[i][property]] = true;
            uniqueArray.push(array[i]);
        }
        return uniqueArray;
    }

    public pushWithDistinct<T>(array: Array<T>, item: T, uniqueProp: string): Array<T> {

        if (!array || !item || !uniqueProp) {
            return array;
        }

        const index = array.map(a => a[uniqueProp]).indexOf(item[uniqueProp]);

        if (index === -1) {
            array.push(item);
            return array;
        }
        array[index] = item;
        return array;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/helpers/helpers.service.ts